import { useEffect } from 'react'
import { useGlobalConfig } from 'context/GlobalContext'
import { ANALYTICS_EVENTS } from 'framework/analytics/AnalyticsEvents'

export const WorkflowListPage = () => {

  const { rc } = useGlobalConfig()

  useEffect(() => {
    rc.analytics.trackEvent(ANALYTICS_EVENTS.WORKFLOW.LIST_LOADED)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <h1>Workflow List</h1>
    </div>
  )
}